module.exports = __webpack_public_path__ + "static/img/12.18492ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/12.png
// module id = WOgw
// module chunks = 0